import React, { useEffect, useState } from 'react'
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';
import { VariableAccounts } from './VariableAccounts';
import { useSelectorCustom } from '../../../components/general/general-component/abstruct-component/useSelectorCustom';
import { filterAccount, getPageList } from '../../../store/Actions/ActionAccounts';
import SelectDropDown from '../../../components/elements/SelectDropDown';

function FilterAccounts({ translate, noPadding, bigTitle }) {
    const { dispatch, navigate, langLocal } = AbstructVar()
    const { state, setStateCustom, setLoad, handleChangeDate } = VariableAccounts();
    const [projectId, setProjectId] = useState('')
    const { page_list, loadingPageList } = useSelectorCustom()
    useEffect(() => {
        dispatch(getPageList())
    }, [])
    const Filter = (e) => {
        e.preventDefault()
        dispatch(filterAccount(state.name, state.account_type_id,state.user_id,state.statusFilter, setLoad))
    }
    return (
        <div className='filteruser ' dir={langLocal === 'ar' ? "rtl" : "ltr"} style={noPadding && { padding: "20px 25px 10px 25px" }} >
            {
                bigTitle ? <h2 className="main_title_color" >{translate('search_filter')}</h2> :
                    <h3>{translate('search_filter')}</h3>
            }
            <div className='div_filter' style={{ paddingTop: '10px' }} >
                <div style={{ marginTop: "15px" }} className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"}  w-24 new-input-filter`} >
                    <input type='text' className={`input_filter1 ${langLocal === 'ar' ? "margin_left_25" : "margin_right_25"} `} placeholder={translate('name')} onChange={(e) => setStateCustom('name', e.target.value)} />
                </div>
                <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`} style={{ fontSize: "14px" }} >
                    <SelectDropDown
                        placeholder={translate('type')}
                        options={page_list?.account_types?.map((type) => ({
                            label: type?.name, value: type?.id
                        }))}
                        varr={state?.account_type_id}
                        setVarr={(value) => setStateCustom('account_type_id', value)}
                    />
                </div>
                <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`} style={{ fontSize: "14px" }} >
                    <SelectDropDown
                        placeholder={translate('users')}
                        options={page_list?.users?.map((user) => ({
                            label: user?.name, value: user?.id
                        }))}
                        varr={state?.user_id}
                        setVarr={(value) => setStateCustom('user_id', value)}
                    />
                </div>
                <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`} style={{ fontSize: "14px" }} >
                    <SelectDropDown
                        placeholder={translate('status')}
                        options={[{label: "active",value: 1},{label: "unactive",value: 0}]}
                        varr={state?.status}
                        setVarr={(value) => setStateCustom('status', value)}
                    />
                </div>
                <button className='btn_filter' onClick={Filter}  >
                    {
                        state.Load ? "Loading ..." : `${translate('filter')}`
                    }
                </button>
            </div>
        </div>
    )
}

export default FilterAccounts



